<!-- gwtg -->
<template>
  <div class="source_record">
    <div class="title">
      <i></i>
      <b></b>
      素材发布记录
    </div>
    <div>
      <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
        <el-tab-pane label="全部" name=""></el-tab-pane>
        <el-tab-pane label="未审核" name="1"></el-tab-pane>
        <el-tab-pane label="审核通过" name="2"></el-tab-pane>
        <el-tab-pane label="审核未通过" name="3"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="s-p">
      <el-date-picker
        v-model="value2"
        type="daterange"
        class="dateTime"
        align="left"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="YYYY-MM-DD"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
      <div class="ml-1">
        <el-button @click="getList" class="btn2" type="primary">查询</el-button>
        <el-button class="btn3" @click="reset">重置</el-button>
        <el-button type="primary" :disabled="isDisabled" @click="changePrice">添加折扣</el-button>
      </div>
    </div>
    <div class="t-p">
      <el-table
        class="v-t-table"
        stripe
        height="650px"
        v-loading="loading"
        :data="tableData.list"
        style="width: 100%;overflow-y:scroll"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" align="center" />
        <el-table-column type="index" label="序号" align="center" width="80" />
        <el-table-column prop="name" label="素材名称" align="center" />
        <el-table-column prop="fengmianUrl" label="封面" align="center">
          <template slot-scope="scope">
            <el-image
              style="width: 60px; height: 60px"
              :src="`${apiBaseImgUrl}${scope.row.fengmianUrl}`"
              :preview-src-list="[`${apiBaseImgUrl}${scope.row.fengmianUrl}`]"
              title="点击查看大图"
            >
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="其他图片" align="center" width="280px">
          <template slot-scope="scope">
            <el-image
              v-for="(item, index) in scope.row.imageUrlList"
              :key="index"
              style="width: 60px; height: 60px;margin-right: 5px;"
              :src="item"
              :preview-src-list="scope.row.imageUrlList"
              title="点击查看大图"
            >
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="素材附件" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.materialName">{{
              scope.row.materialName ? scope.row.materialName : ""
            }}</span>
            <a
              :href="`${apiBaseImgUrl}${scope.row.materialUrl}`"
              download
              v-if="role == 1"
            >
              <el-button type="text">下载附件</el-button>
            </a>
          </template>
        </el-table-column>
        <el-table-column label="素材类型" align="center">
          <template slot-scope="scope">
            <span>{{ flagType[scope.row.type] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="素材金额（元）" align="center" />
        <el-table-column prop="discountPrice" label="折后金额（元）" align="center" />
        <el-table-column prop="name" label="地址" align="center" />
        <el-table-column label="审核状态" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row.isAudit == 1
                ? "未审核"
                : scope.row.isAudit == 2
                ? "审核通过"
                : "审核未通过"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="auditReason" label="审核原因" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="上传时间" align="center">
          <template slot-scope="scope">
            <span>{{
              $dayjs(scope.row.createTime).format("YYYY-MM-DD HH:mm:ss")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          width="130px"
        >
          <template slot-scope="scope">
            <el-button
              title="审核通过"
              v-if="
                (scope.row.isAudit == 3 || scope.row.isAudit == 1) && role == 1
              "
              @click="handleClick(scope.row, '2')"
              type="text"
              class="mr-1"
              ><i class="el-icon-check"></i
            ></el-button>
            <el-popover
              placement="bottom-start"
              width="250"
              trigger="click"
              v-model="scope.row.visible"
            >
              <p>
                <el-input
                  v-model="scope.row.auditReason"
                  placeholder="请输入未通过原因"
                ></el-input>
              </p>
              <div style="text-align: right; margin: 0;margin-top: 5px;">
                <el-button
                  size="mini"
                  type="text"
                  @click="scope.row.visible = false"
                  >取消</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click="handleClick(scope.row, '3')"
                  >确定</el-button
                >
              </div>
              <span
                slot="reference"
                v-if="
                  (scope.row.isAudit == 2 || scope.row.isAudit == 1) &&
                    role == 1
                "
                class="mr-1"
                title="审核未通过"
              >
                <el-button type="text"
                  ><i class="el-icon-close text-danger"></i
                ></el-button>
              </span>
            </el-popover>
            <el-button
              title="删除素材"
              @click="handleDelete(scope.row)"
              type="text"
              ><i class="el-icon-delete"></i
            ></el-button>
            <el-button
              @click="handleTuiJian(scope.row, 1)"
              v-if="role == 1"
              :type="scope.row.tuijian == 1 ? 'success' : 'primary'"
              >{{ scope.row.tuijian == 1 ? "已推荐" : "未推荐" }}</el-button
            >
            <el-button
              @click="handleTuiJian(scope.row, 2)"
              class="mt-2"
              v-if="role == 1"
              :type="scope.row.lunbo == 1 ? 'success' : 'primary'"
              >{{ scope.row.lunbo == 1 ? "已轮播" : "未轮播" }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="p-p">
      <el-pagination
        class="page"
        background
        layout="prev, pager, next"
        @current-change="changePage"
        :current-page="searchParams.pageNo"
        :total="tableData.total"
        :page-size="searchParams.pageSize"
      />
    </div>
    <el-dialog
      title="添加折扣"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <div>
        <div class="flex" style="height:32px">
          <div style="width:120px;line-height:32px">请输入折扣:</div>
          <el-input v-model.number="form.discount" type="number" oninput="value=value.replace(/^0|[^0-9]/g,'')" placeholder="请输入数字(例如:8折输入8或80;85折只需输入85)"></el-input>  
          <el-button type="primary" plain class="ml-1" @click="commitChange">确认打折</el-button>
        </div>
        <div class="flex justify-content-between mt-2 pl-2 pr-4">
          <ul>
            <li style="font-size:15px;font-weight:600">作品名称</li>
            <li v-for="(item,index) in nameList" :key="index" class="mt-1">{{item}}</li>
          </ul>
          <ul>
            <li style="font-size:15px;font-weight:600">商品原价</li>
            <li v-for="(item,index) in originalPrice" :key="index" class="mt-1">{{item}}</li>
          </ul>
          <ul>
            <li style="font-size:15px;font-weight:600">打折后的价格</li>
            <li v-for="(item,index) in salePrice" :key="index" class="mt-1">{{item}}</li>
          </ul>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="cancel()">取 消</el-button>
        <el-button type="primary" @click="confirm()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiBaseImgUrl } from "@/server/api";
export default {
  data() {
    return {
      tableData: [],
      activeName: "",
      value2: [],
      reasonValue: "",
      defaultSearchParams: {},
      loading: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      flagType: {
        1: "CAD户型图",
        2: "设计案例",
        3: "CAD图库",
        4: "高清贴图",
        16:"进口家具",
      },
      visible: false,
      apiBaseImgUrl: "",
      role: "",
      searchParams: {
        createTimeStart: "",
        createTimeEnd: "",
        pageNo: 1,
        pageSize: 10,
        isAudit: "",
      },
      multipleSelection: [],
      isDisabled: true,
      form:{
        discount:'',
        ids:[],
      },
      dialogVisible:false,
      nameList:[],
      salePrice:[],
      originalPrice:[],
    };
  },
  created() {},
  mounted() {
    this.getList();
    this.role = sessionStorage.getItem("role");
    this.defaultSearchParams = JSON.parse(JSON.stringify(this.searchParams));
    this.apiBaseImgUrl = apiBaseImgUrl;
  },
  methods: {
    setVal(url, fileName) {},
    handleTuiJian(row, type) {
      if (row.isAudit == 1) {
        this.$message.warning("请先进行审核通过后，方可进行推荐或轮播");
        return;
      }
      if (row.isAudit == 3) {
        this.$message.warning("该作品为审核未通过状态，不可进行推荐或轮播");
        return;
      }
      if (row.tuijian == 2 && type == 1) {
        this.$post("/tjorlb/addTuijianOrLunBo", {
          micIdList: [row.id],
          type,
        }).then((res) => {
          if (res.message == "已经存在轮播图") {
            this.$message.error(`${res.message}，请取消已存在轮播再添加`);
          } else {
            this.$message.success(type == 1 ? "添加推荐成功" : "添加轮播成功");
          }
          this.getList();
        });
      } else if (row.lunbo == 2 && type == 2) {
        this.$post("/tjorlb/addTuijianOrLunBo", {
          micIdList: [row.id],
          type,
        }).then((res) => {
          if (res.message == "已经存在轮播图") {
            this.$message.error(`${res.message}，请取消已存在轮播再添加`);
          } else {
            this.$message.success(type == 1 ? "添加推荐成功" : "添加轮播成功");
          }
          this.getList();
        });
      } else if (row.lunbo == 1 && type == 2) {
        this.$post("/tjorlb/deleteMyTuijianByMcIdAndType", {
          micIdList: [row.id],
          type,
        }).then((res) => {
          this.$message.success(type == 1 ? "取消推荐成功" : "取消轮播成功");
          this.getList();
        });
      } else if (row.tuijian == 1 && type == 1) {
        this.$post("/tjorlb/deleteMyTuijianByMcIdAndType", {
          micIdList: [row.id],
          type,
        }).then((res) => {
          this.$message.success(type == 1 ? "取消推荐成功" : "取消轮播成功");
          this.getList();
        });
      }
    },
    handleClick(row, examineType) {
      const p = {
        id: row.id,
        isAudit: examineType,
        isDeleted: "",
        auditReason: examineType == 2 ? "审核通过" : row.auditReason,
      };
      this.$post("materialCenter/updateAuditById", p).then((res) => {
        if (examineType == 2) {
          this.$message.success("审核通过");
        } else {
          this.$message.success("审核未通过");
        }
        this.getList();
      });
    },
    handleDelete(row) {
      if (row.lunbo == 1) {
        this.$message.warning("该素材已设为轮播，请先取消");
        return;
      }
      if (row.tuijian == 1) {
        this.$message.warning("该素材已设为推荐，请先取消");
        return;
      }
      const p = {
        materialCenterId: row.id,
      };
      this.$get("materialCenter/delMaterialCenterById", p).then((res) => {
        this.$message.success("删除素材成功");
        this.getList();
      });
    },
    downMaterial(row) {
      if (!row.materialUrl) {
        this.$message.warning("该素材没有上传附件");
      }
      const p = {
        downLoadAddr: row.materialUrl,
        oldFileName: row.materialName ? row.materialName : "",
      };
      this.$get("file/download", p, {
        headers: {
          "Content-Type": "application/json",
        },
      }).then((res) => {
        console.log(res);
      });
      // const link = document.createElement("a");
      // link.href = `${apiBaseImgUrl}${row.materialUrl}`;
      // link.download = "素材附件.rar";
      // link.click();
    },
    handleTabClick() {
      this.searchParams.isAudit = this.activeName;
      this.getList();
    },
    //全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if(this.multipleSelection.length > 0){
        this.isDisabled = false
      }else{ this.isDisabled = true }
      this.form.ids = val.map((item) => item.id)
    },
    reset() {
      this.value2 = [];
      this.searchParams.createTimeStart = "";
      this.searchParams.createTimeEnd = "";
    },
    changePage(page) {
      this.searchParams.pageNo = page;
      this.getList();
    },
    changePrice(){
      this.dialogVisible = true
      this.nameList = this.multipleSelection.map((item) => item.name)
      this.originalPrice = this.multipleSelection.map((item)=>item.price)
    },
    async commitChange(){
      let lengthStr = (this.form.discount.toString()).length
      if(lengthStr == 1){
        this.form.discount = (this.form.discount/10).toFixed(2)
      }else if(lengthStr == 2){
        this.form.discount = (this.form.discount/100).toFixed(2)
      }
      this.salePrice = this.originalPrice.map((item)=>{
        return (item * this.form.discount).toFixed(2)
      })
      const p1 = {
        ...this.form
      }
      await this.$post("materialCenter/changePrice",p1).then((res) => {
        if(res.code == 200){
          this.$message({
            message:"操作成功",
            type:"success"
          })
        }
      })
    },
    cancel(){
      this.nameList = []
      this.salePrice = []
      this.originalPrice = []
      this.form.discount ='';
      this.dialogVisible = false
    },
    confirm(){
      this.dialogVisible = false
      this.nameList = []
      this.salePrice = []
      this.originalPrice = []
      this.form.discount ='';
      this.$nextTick(()=>{
        this.getList()
      })
    },
    getList() {
      if (this.value2.length > 0) {
        this.searchParams.createTimeStart = this.value2[0];
        this.searchParams.createTimeEnd = this.value2[1];
      }
      const p = {
        // userId: localStorage.getItem("userId"),
        ...this.searchParams,
      };
      this.loading = true;
      this.$post("materialCenter/queryMaterialCenterList", p).then((res) => {
        this.tableData = res.data;
        this.tableData.list.map((d) => {
          let arr = [];
          d.imageUrlList.map((item) => {
            arr.push(`${apiBaseImgUrl}${item}`);
          });
          d.imageUrlList = arr;
          d.visible = false;
          return d;
        });
        this.loading = false;
      });
    },
  },
  components: {},
  computed: {},
};
</script>
<style lang="less">
.el-message {
  min-width: 40px;
}
.add-dialog,
.view-dialog {
  position: absolute;
}
.el-table tbody tr:hover > td {
  background-color: transparent !important;
}
.el-table__body tr.hover-row > td {
  background-color: transparent;
}
</style>
<style lang="less" scoped>
.btn2 {
  margin-left: 8px;
}
.btn3 {
  margin-left: 8px !important;
}

.dateTime {
  width: 500px;
}
.first {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.first-search {
  display: flex;
  height: 40px;
}
.search1 {
  width: 100%;
  display: flex;
  align-items: center;
}

.source_record {
  width: 100%;
  height: 100%;
  background: #ffffff;
  .title {
    display: flex;
    font-size: 22px;
    padding: 0 10px;
    align-items: center;
    line-height: 40px;
    color: #5c80d9;
    border-bottom: 1px solid rgba(229, 229, 229, 1);
    i {
      display: block;
      height: 20px;
      margin-right: 1px;
      border-left: 1px solid #5c80d9;
    }
    b {
      display: block;
      height: 20px;
      margin-right: 8px;
      border-left: 2.5px solid #5c80d9;
    }
  }
  .s-p {
    display: flex;
    width: 100%;
    height: 93px;
    line-height: 56px;
    align-items: center;
    flex-direction: flex-start;
    padding: 0 10px;
    border-bottom: 1px solid #e5e5e5;
    // > * {
    //   margin-right: 10px;
    // }
    // button:last-child {
    //   margin-left: 490px;
    // }
  }
  .t-p {
    padding: 12px 10px;
    width: 100%;
    height: calc(100% - 240px);
    overflow-y: auto;
  }
  .p-p {
    display: flex;
    height: 50px;
    justify-content: center;
    // margin-top: 120px;
    align-items: center;
    text-align: center;
  }
}
/deep/.el-checkbox{
  margin-bottom: 0;
}
</style>
